import React, { useState, useEffect, useContext } from "react";
import { Trans, useTranslation } from "react-i18next";
import {
  EnrollmentStepWrapper,
  EnrollmentStepFooter,
  ReviewRow,
  ReviewBlock,
  ReviewWrapper,
  ReviewDisclaimer,
  EnrollmentFormRow,
  EnrollmentFormCol,
} from "../styles/Enrollment.styled";
import { getEnrollmentRecord, confirmEnrollment, saveEnrollment } from "../../fetch/enrollment";
// import { toast } from 'react-toastify'
import { Button } from "../styles/Button.styled";
import { Spinner } from "react-bootstrap";
import { LoadingRow } from "../LoadingRow";
import moment from "moment";
import { RollingTextLoading } from "../RollingTextLoading";
import { CheckboxItem } from "../CheckboxItem";
import { EnrollmentContext } from "./enrollment";
import { FormLoading } from ".././FormLoading";
import { useLocation, useNavigate } from "react-router-dom";

interface Props {
  show: boolean;
  enrollmentId: string;
  handleContinue: Function;
  handleBack: Function;
  sign: string;
  specialPro: {
    ssn: string;
    date_of_birth: string;
  };
  handleSSN: Function;
  handleSetName: Function;
  handlePayment: Function;
  handleSetEmail: Function;
  product: string;
}

interface EnrollmentFields {
  billing_address: string;
  billing_city: string;
  billing_state: string;
  billing_zipcode: string;
  date_of_birth: string;
  email: string;
  first_name: string;
  last_name: string;
  phone: string;
  requested_date: string;
  service_address: string;
  service_city: string;
  service_state: string;
  service_type: string;
  ssn: string;
}

export const EnrollmentStepReview: React.FC<Props> = ({
  show,
  enrollmentId,
  handleContinue,
  handleBack,
  sign,
  specialPro,
  handleSSN,
  handleSetName,
  handlePayment,
  handleSetEmail,
  product
}) => {
  const { t } = useTranslation("enrollment");
  const [reviewData, setReviewData] = useState<EnrollmentFields | undefined>(
    undefined
  );
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [isAgreeRecord, setIsAgreeRecord] = useState(false);
  const [isAgreeCredit, setIsAgreeCredit] = useState(false);
  const [isAgreeLegal, setIsAgreeLegal] = useState(false);
  const [isAgreeDoc, setIsAgreeDoc] = useState(false);
  const [isAgreeContact, setIsAgreeContact] = useState(false);
  const [showConsentError, setShowConsentError] = useState<String[]>([]);
  const [repName, setRepName] = useState("");
  const { serviceAddress, promoCode, handleSetErrorModalContent } =
    useContext<any>(EnrollmentContext);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (enrollmentId && show) {
      getEnrollmentRecord(enrollmentId, sign).then((res) => {
        if (res && parseInt(res.status) === 1) {
          setReviewData(res.response);
          setLoading(false);
        }
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);
  useEffect(() => {
    if (!show) return;
    window.digitalData.page.pageInfo.pageName = "Funnel Step 3"
  }, [show])

  const handleSubmit = () => {
    let newConsentError: String[] = [];
    if (!isAgreeRecord) newConsentError.push("record");

    setShowConsentError(newConsentError);
    if (newConsentError.length > 0) return;
    if (submitting) return;

    setSubmitting(true);

    try {
      const consentFields: any = {};
      consentFields['product'] = product;
      consentFields['sms_marketing_consent'] = isAgreeContact;
      saveEnrollment(enrollmentId, consentFields, sign).then(() => {
        confirmEnrollment(
          enrollmentId,
          specialPro,
          sign
        ).then((res) => {
          if (res) {
            if (res.error_code) {
              navigate(`/enrollment/failed${location.search}`);
            }
            if (res.error_code && res.error_code === "500") {
              setSubmitting(false);
              handleSetErrorModalContent({
                title:
                  res.message || t("The enrollment request has been submitted"),
              });
              // toast.error(res.message || t('The enrollment request has been submitted'))
              return;
            }
            const { status } = res;
            if (status) {
              const errorCode = status.split(".")[0];
              switch (errorCode) {
                case "-1":
                  setSubmitting(false);
                  handleSetErrorModalContent({
                    title: res.message ? t(res.message) : t("An error occurred"),
                  });
                  break;
                case "0":
                  navigate(`/enrollment/failed${location.search}`);
                  setSubmitting(false);
                  if (
                    res.message &&
                    (res.message.toLowerCase().indexOf("email_repeated") >= 0 ||
                      res.message.toLowerCase().indexOf("email_enrolled") >= 0)
                  ) {
                    handleSetErrorModalContent({
                      title: "Are you a current customer?",
                      desc: "It looks like you already have an account with us, please login to continue.",
                      button: "login",
                    });
                  } else {
                    handleSetErrorModalContent({
                      title: t(res.message),
                    });
                  }
                  // toast.error(t(res.message))
                  if (res.message && res.message.indexOf("promoCode") >= 0) {
                    handleBack();
                    localStorage.setItem("promoCodeError", "1");
                  }
                  break;
                case "30":
                  navigate(`/enrollment/failed${location.search}`)
                  // if (
                  //   res &&
                  //   res.additional &&
                  //   res.additional[0] &&
                  //   res.additional[0].account_number === null
                  // ) {
                  //   const depositAmount = res.additional[0].deposit_amount
                  //     ? res.additional[0].deposit_amount
                  //     : 0;
                  //   setSubmitting(false);
                  //   handleSetErrorModalContent({
                  //     title: `A deposit is required to continue with this enrollment. Deposit amount: $${depositAmount}. Please give us a call at 855-411-0497. Our representatives are available to assist you Monday – Friday from 8:00am – 7:00pm CST.`,
                  //     desc: " ",
                  //     buttonTest: "Cancel",
                  //   });
                  // } else {
                  handleSSN(specialPro);
                  handleContinue(res);
                  handleSetName(
                    `${reviewData
                      ? `${reviewData.first_name} ${reviewData.last_name}`
                      : ""
                    }`
                  );
                  // }
                  break;
                case "20":
                  localStorage.setItem('enrollmentResult', JSON.stringify(res));
                  handlePayment(res);
                  navigate(`/enrollment/deposit${location.search}`)
                  break
                case "10":
                  navigate(`/enrollment/success${location.search}`);
                  handleSSN(specialPro);
                  handleContinue(res);
                  handleSetEmail(reviewData ? reviewData.email : '')
                  handleSetName(
                    `${reviewData
                      ? `${reviewData.first_name} ${reviewData.last_name}`
                      : ""
                    }`
                  );
                  break;
                case "40":
                case "50":
                  navigate(`/enrollment/failed${location.search}`);
                  handleSSN(specialPro);
                  handleContinue(res);
                  handleSetName(
                    `${reviewData
                      ? `${reviewData.first_name} ${reviewData.last_name}`
                      : ""
                    }`
                  );
                  break;
                default:
              }
            }
          } else {
            navigate(`/enrollment/failed${location.search}`);
            setSubmitting(false);
            handleSetErrorModalContent({
              title: t("An error occurred"),
            });
            // toast.error(t('An error occurred'))
          }
        });
      }
      )

    } catch (error) {
      setSubmitting(false);
      handleSetErrorModalContent({
        title: t("An error occurred"),
      });
      // toast.error(t('An error occurred'))
    }
  };

  const getContent = () => {
    if (loading || !reviewData)
      return (
        <div className="pt-5 pb-5">
          <LoadingRow />
        </div>
      );

    const {
      billing_address,
      billing_city,
      billing_state,
      billing_zipcode,
      date_of_birth,
      email,
      first_name,
      last_name,
      phone,
      requested_date,
      service_address,
      service_city,
      service_state,
      service_type,
      ssn,
    } = reviewData;

    return (
      <ReviewWrapper className="position-relative">
        <h5 className="mb-5">
          {t("Please double check your enrollment details")}
        </h5>
        <ReviewBlock>
          <h6>{t("Service Information")}</h6>
          <ReviewRow>
            <label>{t("Service Address")}:</label>
            <span>{`${service_address} ${service_city} ${service_state}, ${serviceAddress[0].zipcode}`}</span>
          </ReviewRow>
          <ReviewRow>
            <label>{t("Billing Address")}:</label>
            <span>{`${billing_address} ${billing_city} ${billing_state}, ${billing_zipcode}`}</span>
          </ReviewRow>
          <ReviewRow>
            <label>{t("Service Type")}:</label>
            <span>{service_type}</span>
          </ReviewRow>
          <ReviewRow>
            <label>{t("Requested Date")}:</label>
            <span>{moment(requested_date).format("MM/DD/YYYY")}</span>
          </ReviewRow>
          {promoCode && (
            <ReviewRow>
              <label>Promo Code:</label>
              <span>{promoCode}</span>
            </ReviewRow>
          )}
        </ReviewBlock>
        <ReviewBlock>
          <h6>{t("Customer Information")}</h6>
          <ReviewRow>
            <label>{t("Customer Name")}:</label>
            <span>{`${first_name} ${last_name}`}</span>
          </ReviewRow>
          {phone && (
            <ReviewRow>
              <label>{t("Phone")}:</label>
              <span>{phone}</span>
            </ReviewRow>
          )}
          <ReviewRow>
            <label>{t("Email")}:</label>
            <span>{email}</span>
          </ReviewRow>
          {moment(date_of_birth).isValid() && (
            <ReviewRow>
              <label>{t("Date of Birth")}:</label>
              <span>{moment(date_of_birth).format("MM/DD/YYYY")}</span>
            </ReviewRow>
          )}
          {ssn && (
            <ReviewRow>
              <label>{t("SSN")}:</label>
              <span>*****{ssn.substr(5)}</span>
            </ReviewRow>
          )}
        </ReviewBlock>
        <EnrollmentFormRow>
          <EnrollmentFormCol full>
            <div className="checkbox-row">
              <p style={{ fontSize: "1.1rem" }}>Check the box(es) on the left to agree to the terms below:</p>
              <CheckboxItem
                // eslint-disable-next-line react/jsx-key
                label=""
                value={`${isAgreeRecord}`}
                checked={isAgreeRecord}
                handleClick={() => {
                  let [...newShowConsentError] = showConsentError;
                  const pos = showConsentError.indexOf("record");
                  if (pos >= 0) {
                    newShowConsentError.splice(pos, 1);
                    setShowConsentError(newShowConsentError);
                  }
                  setIsAgreeRecord(!isAgreeRecord);
                }}
                onlyread={false}
                disabled={loading}
                error={showConsentError.indexOf("record") >= 0}
                renderLabel={() => (
                  <>
                    <span>
                      I consent to the use of electronic records and signatures including the provision of state and federal disclosures in place of written documentation and handwritten signatures in connection with my enrollment application.
                    </span>
                    <span style={{ marginTop: "20px" }}>
                      I authorize Constellation to share my customer information with its affiliates and its and their third party providers, provided that each such recipient agrees to hold such information in confidence.
                    </span>
                    <span style={{ marginTop: "20px" }}>
                      I agree on behalf of myself, the applicant, that I am demonstrating the ability to access and view all enrollment information in the electronic formats disclosed above and agree to print and keep a copy of this enrollment for my records.
                    </span>
                  </>
                )}
              />
            </div>
            {/* <div className="checkbox-row">
              <CheckboxItem
                label={`I authorize ${repName} to obtain information from my credit report to determine whether a deposit is required.`}
                value={`${isAgreeCredit}`}
                checked={isAgreeCredit}
                handleClick={() => {
                  let [...newShowConsentError] = showConsentError;
                  const pos = showConsentError.indexOf("credit");
                  if (pos >= 0) {
                    newShowConsentError.splice(pos, 1);
                    setShowConsentError(newShowConsentError);
                  }
                  setIsAgreeCredit(!isAgreeCredit);
                }}
                onlyread={false}
                disabled={loading}
                error={showConsentError.indexOf("credit") >= 0}
              />
            </div>
            <div className="checkbox-row">
              <CheckboxItem
                label={`I certify I am over 18 years of age and legally authorized to change the Retail Electric Provider for the address listed under Service Information. I agree that I have decided to change service from my current REP to ${repName}. I affirm that I designated ${repName} to perform the tasks necessary to complete a switch for me at this address.`}
                value={`${isAgreeLegal}`}
                checked={isAgreeLegal}
                handleClick={() => {
                  let [...newShowConsentError] = showConsentError;
                  const pos = showConsentError.indexOf("legal");
                  if (pos >= 0) {
                    newShowConsentError.splice(pos, 1);
                    setShowConsentError(newShowConsentError);
                  }
                  setIsAgreeLegal(!isAgreeLegal);
                }}
                onlyread={false}
                disabled={loading}
                error={showConsentError.indexOf("legal") >= 0}
              />
            </div>
            <div className="checkbox-row">
              <CheckboxItem
                label={`I have read and accept the Terms of Service, EFL, and YRAC, and I agree to receive all contract documents and other written communications electronically from ${repName}.`}
                value={`${isAgreeDoc}`}
                checked={isAgreeDoc}
                handleClick={() => {
                  let [...newShowConsentError] = showConsentError;
                  const pos = showConsentError.indexOf("doc");
                  if (pos >= 0) {
                    newShowConsentError.splice(pos, 1);
                    setShowConsentError(newShowConsentError);
                  }
                  setIsAgreeDoc(!isAgreeDoc);
                }}
                onlyread={false}
                disabled={loading}
                error={showConsentError.indexOf("doc") >= 0}
              />
            </div> */}
            <div className="checkbox-row">
              <p style={{ fontSize: "1.1rem" }}>Check the box below to opt in to receiving SMS notifications from Constellation about your Electricity order.</p>
              <CheckboxItem
                label=""
                value={`${isAgreeContact}`}
                checked={isAgreeContact}
                handleClick={() => {
                  let [...newShowConsentError] = showConsentError;
                  const pos = showConsentError.indexOf("contact");
                  if (pos >= 0) {
                    newShowConsentError.splice(pos, 1);
                    setShowConsentError(newShowConsentError);
                  }
                  setIsAgreeContact(!isAgreeContact);
                }}
                onlyread={false}
                disabled={loading}
                error={showConsentError.indexOf("contact") >= 0}
                renderLabel={() => (
                  <>
                    {/* <span>
                      I would like to receive text messages about my Electricity order, order status, and related offers at the number entered above, including identity verification.
                    </span> */}
                    <span>
                      By checking this box, I agree to receive recurring automated marketing text messages and automated/prerecorded marketing calls from Constellation to the phone number provided in this form. I understand that providing consent is not a condition of completing this transaction.
                      {/* I hereby consent to receive autodialed and or pre-recorded telemarketing calls and/or text messages from or on behalf of Constellation at the telephone number listed above. I understand that this consent is not a condition of purchasing any goods or services from Constellation. */}
                    </span>
                  </>
                )}
              />
            </div>
          </EnrollmentFormCol>
        </EnrollmentFormRow>
        <EnrollmentStepFooter>
          <Button secondary disabled={submitting} onClick={() => handleBack()}>
            {t("Back")}
          </Button>
          <Button
            type="button"
            onClick={() => {
              handleSubmit();
            }}
            data-test-id="cta"
          >
            <span>{t("Submit")}</span>
            {submitting && (
              <Spinner
                animation="border"
                variant="light"
                size="sm"
                className="ms-2"
              />
            )}
          </Button>
        </EnrollmentStepFooter>
        {/* <ReviewDisclaimer>
          {t(
            "By clicking 'Submit', you agree that your information will be sent to Constellation.com for their review and approval, and a soft credit check will be run to assist with that review."
          )}
        </ReviewDisclaimer> */}
        <FormLoading
          show={submitting}
          content={t("This process may take up to 1 minute", { ns: "common" })}
        />
        {/* <RollingTextLoading
                    text={[
                        t('This process may take up to 1 minute', { ns: 'common' }),
                        t(
                            'We are transmitting your information to the Retail Energy Provider(REP)...',
                            { ns: 'common' }
                        ),
                        t('Be patient while REP is reviewing your application', { ns: 'common' }),
                        t('REP is still verifying your information...', { ns: 'common' }),
                        t("We are waiting for REP's approval...", { ns: 'common' }),
                        t('Get the approval in a few seconds', { ns: 'common' }),
                    ]}
                    show={submitting}
                /> */}
      </ReviewWrapper>
    );
  };

  if (!show) return null;
  return <EnrollmentStepWrapper>{getContent()}</EnrollmentStepWrapper>;
};
